import React from 'react';
const Loader = () => {
  return (
    <>
      {' '}
      <div className="" style={{ background: 'black' }}>
        {' '}
        <svg
          viewBox="0 0 400 160"
          className=" w-[100%] h-[100vh] fill-black font-bold"
        >
          {' '}
          <text
            x={'50%'}
            y={'50%'}
            dy={'.32em'}
            textAnchor="middle"
            className=" stroke-green-500 stroke-2 text-5xl lg:text-[50px] text-black tracking-[-3.2px] dark:animate-lineUp animate-lineUp "
          >
            {' '}
            Coder_Dave{' '}
          </text>{' '}
          <text
            x={'50%'}
            y={'50%'}
            dy={'.32em'}
            dx={'2.8em'}
            textAnchor="middle"
            className="stroke-green-500 stroke-2 text-5xl dark:animate-lineUp animate-lineUp "
          >
            {' '}
            .{' '}
          </text>{' '}
        </svg>{' '}
        ;{' '}
      </div>{' '}
    </>
  );
};
export default Loader;
